import {ExternalBackend} from "./ExternalBackend";

export class EpochWorkflow extends ExternalBackend {

  constructor(params) {
    super("epoch", params);
  }
}
